import $ from 'jquery';
import 'select2';
import React, { useEffect, useRef } from 'react';
import {
    Options
} from "select2";
import { observer } from "mobx-react";

export interface Select2Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
    data?: Options,
    value?: string | number | string[] | undefined,
    isActive?: boolean,
}

const Select2Wrapper = observer((props: Select2Props) => {

    const element = useRef(null);

    useEffect(() => {

        let el = element.current;

        if(el !== null){

            let elements = $(el);

            elements.select2(
                props.data !== undefined
                    ? props.data : {}
            ).on("select2:select", (event: any) => {
                if(props.onChange !== undefined) {
                    props.onChange(event)
                }
            });

            if(props.value !== undefined) {
                elements.val(props.value).trigger('change.select2');
            }
        }
    }, [props.data, props.value]);

    return(
        <select {...props} ref={element} >
            {props.children}
        </select>
    );
})

export default Select2Wrapper;